import { useMemo, useRef } from 'react';
import { LoadContext } from './LoadContext';
export function LoadProvider(props) {
    const { children, loading, loadingRows, loadingColumns } = props;
    const initialLoading = useRef(loading);
    if (!loading && initialLoading.current) {
        initialLoading.current = false;
    }
    const value = useMemo(() => ({ loading, loadingRows, loadingColumns, initialLoading: initialLoading.current }), [loading, loadingRows, loadingColumns]);
    return <LoadContext.Provider value={value}>{children}</LoadContext.Provider>;
}
